import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import styles from './SocialIcon.module.scss';

export default function SocialIcon({ icon, link }: { icon: IconDefinition; link: string }) {
  return (
    <a className={styles.socialIcon} href={link} target="_blank" rel="noreferrer">
      <FontAwesomeIcon className={`${styles.icon} fa-fw fa-inverse`} icon={icon} />
    </a>
  );
}
